export default "__VITE_ASSET__CWby4y$7__"